import { render, staticRenderFns } from "./PersonalizedGameEditorAudio.vue?vue&type=template&id=6fcda2fe&scoped=true&"
import script from "./PersonalizedGameEditorAudio.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcda2fe",
  null
  
)

export default component.exports